import React from 'react';
import { Link } from "react-router-dom";


class ToContactButton extends React.Component{
    render(){
        return(
            <Link to={{pathname:"/Contact"}}>
            <div className>
                <button className = "btn btn-secondary">Please Contact Us To Learn More!</button>
            </div>            
            </Link>
        )
    }
}

export default ToContactButton;